import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import * as React from "react";
import { ContentWrapper } from "../../styled";
import styled from "../../../styled-components";
import { mediaCSS } from "@redocly/reference-docs";
export default function UserMarkdownLayout(a) {
  var b = a.withToc,
      c = a.lastModifiedAgo,
      d = a.Toc,
      e = a.children,
      f = a.lastModified;
  return /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, {
    withToc: b
  }, c && /*#__PURE__*/React.createElement(PageInfo, null, /*#__PURE__*/React.createElement(PageInfoText, {
    "data-cy": "last-updated",
    dateTime: f === null || f === void 0 ? void 0 : f.toString()
  }, "Last updated ", /*#__PURE__*/React.createElement("span", null, c))), e), /*#__PURE__*/React.createElement(d, null));
}
export var PageWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  width: 100%;\n"])));
var PageInfo = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: 0.8125rem;\n  margin-bottom: 1.5em;\n"]))),
    PageInfoText = styled.time(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: ", ";\n  ", "\n\n  @media print {\n    > span {\n      display: none;\n    }\n    &::after {\n      content: attr(datetime);\n    }\n  }\n"])), function (a) {
  return a.theme.colors.text.primary;
}, function (a) {
  return a.theme.typography.fontWeightRegular;
}, function (_ref) {
  var a = _ref.theme;
  return mediaCSS({
    fontFamily: a.typography.fontFamily
  });
});